<div id="products" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg"
      fxLayout="column" fxLayoutAlign="center center"
      fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">

      <!-- APP TITLE -->
      <div class="logo my-12 m-sm-0"
        fxLayout="row" fxLayoutAlign="start center">
        <mat-icon class="logo-icon mr-16" *fuseIfOnDom >format_list_numbered</mat-icon>
        <span class="logo-text h1" *fuseIfOnDom >{{'main.targetGroup' | translate}}</span>
      </div>
      <!-- / APP TITLE -->

      <!-- SEARCH -->
      <div class="search-input-wrapper mx-12 m-md-0 width-5-10"
        fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">
        <label for="search" class="mr-8">
          <mat-icon class="secondary-text">search</mat-icon>
        </label>
        <!-- USE IT TO BLOCK CHROME AUTOCOMPLETE -->
        <mat-form-field floatLabel="never" fxFlex="1 0 auto" style="display: none">
          <input id="search1" autocomplete="off" matInput #filter2 placeholder="{{'main.search' | translate}}">
        </mat-form-field>
        <!-- USE IT TO BLOCK CHROME AUTOCOMPLETE -->
        <mat-form-field floatLabel="never" fxFlex="1 0 auto" class="page-search">
          <mat-label>{{'main.search' | translate}}</mat-label>
          <input id="search" matInput #filter>
        </mat-form-field>
      </div>
      <!-- / SEARCH -->

      @if (access && access.add) {
        <button mat-raised-button
          (click)="newTargetGroup()"
          class="add-product-button mat-white-bg my-12 mt-sm-0">
          <span>{{'targetGroup.new' | translate}}</span>
        </button>
      }

    </div>
    <!-- / HEADER -->
    <!-- CONTENT CARD -->
    <div class="content-card mat-white-bg">

      <mat-table class="products-table"
        #table [dataSource]="targetGroups"
        matSort
        [@animateStagger]="{value:'50'}"
        fusePerfectScrollbar>


        <!-- Name Column -->
        <ng-container cdkColumnDef="ageMask">
          <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'targetGroup.ageMask' | translate}}</mat-header-cell>
          <mat-cell *cdkCellDef="let targetGroup">
            <p class="text-truncate">{{targetGroup.ageMask}}</p>
          </mat-cell>
        </ng-container>

        <!-- Name Column -->
        <ng-container cdkColumnDef="targetNumber">
          <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'targetGroup.targetNumber' | translate}}</mat-header-cell>
          <mat-cell *cdkCellDef="let targetGroup">
            <p class="text-truncate">{{targetGroup.targetNumber}}</p>
          </mat-cell>
        </ng-container>

        <ng-container cdkColumnDef="group">
          <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'targetGroup.group' | translate}}</mat-header-cell>
          <mat-cell *cdkCellDef="let targetGroup">
            @if (targetGroup.group) {
              <p class="text-truncate">{{targetGroup.group.name}}</p>
            }
          </mat-cell>
        </ng-container>

        <ng-container cdkColumnDef="abbreviation">
          <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'targetGroup.abbreviation' | translate}}</mat-header-cell>
          <mat-cell *cdkCellDef="let targetGroup">
            <p class="text-truncate">{{targetGroup.abbreviation}}</p>
          </mat-cell>
        </ng-container>

        <ng-container cdkColumnDef="creditTarget">
          <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'targetGroup.creditTarget' | translate}}</mat-header-cell>
          <mat-cell *cdkCellDef="let targetGroup">
            @if (targetGroup.setting) {
              <p class="text-truncate">{{targetGroup.setting.creditTarget}}</p>
            }
          </mat-cell>
        </ng-container>

        <ng-container cdkColumnDef="carryForward">
          <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'targetGroup.nextYear' | translate}}</mat-header-cell>
          <mat-cell *cdkCellDef="let targetGroup">
            @if (targetGroup.setting) {
              <p class="text-truncate">{{targetGroup.setting.maxTransfer}}</p>
            }
          </mat-cell>
        </ng-container>


<!-- Name Column -->
<ng-container cdkColumnDef="active">
  <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'targetGroup.active' | translate}}</mat-header-cell>
  <mat-cell *cdkCellDef="let targetGroup">
    @if (targetGroup.setting && targetGroup.setting.active) {
      <mat-icon class="active">check_circle_outline</mat-icon>
    }
    @if (!targetGroup.setting || !targetGroup.setting.active) {
      <mat-icon class="no_active">highlight_off</mat-icon>
    }
  </mat-cell>
</ng-container>

<ng-container cdkColumnDef="showInFront">
  <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'showInFront' | translate}}</mat-header-cell>
  <mat-cell *cdkCellDef="let targetGroup">
    @if (targetGroup.showInFront ) {
      <mat-icon class="active">check_circle_outline</mat-icon>
    }
    @if (!targetGroup.showInFront) {
      <mat-icon class="no_active">highlight_off</mat-icon>
    }
  </mat-cell>
</ng-container>

<mat-header-row *cdkHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>

<mat-row *cdkRowDef="let level; columns: displayedColumns;"
  class="product"
  matRipple
  (click)="editTargetGroup(level)">
</mat-row>

</mat-table>
@if (targetGroups?.filteredData?.length === 0) {
  <div class="no-data-msg">
    <span class="mat-headline-6">{{'main.noData' | translate}}</span>
  </div>
}
<mat-paginator #paginator
  [length]="targetGroups?.filteredData?.length"
  [pageIndex]="0"
  [pageSize]="50"
  [pageSizeOptions]="[25, 50, 100]">
</mat-paginator>

</div>
<!-- / CONTENT CARD -->
</div>
<!-- / CENTER -->
</div>
